// @flow
const PAGINATION = {
  PREV_PAGE: '<<',
  NEXT_PAGE: '>>'
};

export default PAGINATION;
